import React from "react";
import { Breadcrumb, Card, Form, Input, Modal, Typography } from "antd";
import { Link } from "react-router-dom";

import BaseComponent from "../../redare/components/BaseComponent";
import UserPresenter from "../../.gen/presenter/UserPresenter";
import 'moment/locale/zh-cn';
import { WebPage } from "../../redare_components/webplatform_workbench/utils/WorkbenchDecoratorUtil";
import FunPermission from "../../redare_components/webplatform_workbench/components/permission/FunPermission";

const { Title, Text } = Typography;

export default @WebPage({
    classify: '个人设置',
    id: 'com.redare.webmanager.pages.site.ProfilePage',
    name: '个人设置',
    des: '个人设置',
    webPath: '/site/profile',
    webFunIds: [
        'modifyUser',
        'modifyPwd'
    ],
    props: {
        application: '个人设置'
    }
})
class ProfilePage extends BaseComponent {

    constructor(props) {
        super(props);
        this.userPresenter = new UserPresenter(this);
    }

    state = {
        modal1Visible: false,
        modal2Visible: false
    };

    componentDidMount() {
        this._loadUserInfo();
    }

    _loadUserInfo() {
        this.userPresenter.getCurrentUser({}, (result) => {
            this.setState({ data: result.data });
        })
    }

    //打开修改email窗口
    _toEditEmail(modal1Visible, id) {
        this.setState({ modal1Visible });
        this.setState({ accountId: id });
    }

    _onEmailSubmit(modal1Visible) {
        this.formRef.validateFields().then(values => {
            let modifyData = { email: values.email, where: { userId: this.state.accountId } };
            this.userPresenter.modifyUser(modifyData, {}, (result) => {
                this.toastSuccess("修改成功")
                this.setState({ modal1Visible });
                this._loadUserInfo();
            });
        });
    }

    _toEditPwd(modal2Visible, id) {
        this.setState({ modal2Visible });
        this.setState({ id: id });
    }

    _onPwdSubmit(modal2Visible) {
        this.pwdRef.validateFields().then(values => {
            let modifyPwd = { accountId: this.state.id, pwd: values.pwd };
            this.userPresenter.modifyPwd(modifyPwd, {}, (result) => {
                this.toastSuccess("修改成功");
                this.setState({ modal2Visible });
                this._loadUserInfo();
            })
        });
    }

    render() {
        let { data } = this.state;
        if (!data) {
            data = {};
        }
        return (
            <div className="Profile-Page">
                <div className="bg-white bord-bot">
                    <div className="width-all padding02">
                        <Breadcrumb>
                            <Breadcrumb.Item><Link to="/">工作台</Link></Breadcrumb.Item>
                            <Breadcrumb.Item><Link to="/site">系统设置</Link></Breadcrumb.Item>
                            <Breadcrumb.Item>个人设置</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </div>
                <div className="width-all">
                    <div className="margin024">
                        <Card bordered={false}>
                            <dl className="list-box">
                                <dt className="margin-bottom24"><Title level={4}>基础信息</Title></dt>
                                <dd>
                                    <h4>账户</h4>
                                    <p>{data.account}</p>
                                </dd>
                                <dd>
                                    <h4>姓名</h4>
                                    <p>{data.name}</p>
                                </dd>
                                <dd>
                                    <h4>所属部门</h4>
                                    <p>{data.departmentName}</p>
                                </dd>
                                <dd className="con-box">
                                    <div className="fl">
                                        <div className="con-tit">
                                            <h4>邮箱</h4>
                                            <p>{data.email}</p>
                                        </div>
                                    </div>
                                    <FunPermission funId='modifyUser'>
                                        <div className="fr">
                                            <a onClick={() => this._toEditEmail(true, data.accountId)}>修改</a>
                                        </div>
                                    </FunPermission>
                                </dd>
                            </dl>
                            <dl className="list-box">
                                <dt className="margin-bottom24"><Title level={4}>安全设置</Title></dt>
                                <dd className="con-box">
                                    <div className="fl">
                                        <div className="con-tit">
                                            <h4>账户密码</h4>
                                            <p>********</p>
                                        </div>
                                    </div>
                                    <FunPermission funId='modifyPwd'>
                                        <div className="fr">
                                            <a onClick={() => this._toEditPwd(true, data.accountId)}>修改</a>
                                            {console.log(data)}
                                        </div>
                                    </FunPermission>
                                </dd>
                            </dl>
                        </Card>
                    </div>
                </div>
                <Modal
                    title="修改邮箱"
                    visible={this.state.modal1Visible}
                    onOk={() => this._onEmailSubmit(false)}
                    onCancel={() => this.setState({ modal1Visible: false })}
                    centered={true}
                    okText={'确定'}
                    cancelText={'取消'}
                >
                    <Form layout="vertical" ref={(o) => this.formRef = o}>
                        <Form.Item name="email" rules={[{ type: 'email', message: '邮箱地址不合法' }, { required: true, message: '邮箱地址不能为空' }]}>
                            <Input placeholder="请输入邮箱地址" />
                        </Form.Item>
                    </Form>
                </Modal>
                <Modal
                    title="设置新密码"
                    visible={this.state.modal2Visible}
                    onOk={() => this._onPwdSubmit(false)}
                    onCancel={() => this.setState({ modal2Visible: false })}
                    centered={true}
                    okText={'确定'}
                    cancelText={'取消'}
                >
                    <Form layout="vertical" ref={(o) => this.pwdRef = o}>
                        <Form.Item name="pwd" rules={[{ required: true, message: "密码不能为空" }]}>
                            <Input.Password placeholder="请输入6位以上密码，区分大小写" />
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        )
    }
}
